import { styled } from "@mui/material/styles"

export const PageSection = styled('div')(({
  marginTop: '24px',
  marginBottom: '48px'
}))

